import { Component, OnInit } from '@angular/core';
import { PartnersBaseComponent } from './../common-theme/index';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})

export class PartnersComponent extends PartnersBaseComponent  implements OnInit {
  ngOnInit(): void {
    super.ngOnInit();

    this.setTitle('Partenerii Dream Residence');

    this.setMetaDescription(
      `Printre partenerii proiectului Dream Residence gasesti companii ca BCR, BRD, BT, Mapei, Mega Door, Porta Doors. Afla toate detaliile pe site.`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/partners/partners.component.ts